import { AssignmentStatusByStudentItem } from '../../../../constants/types/lms/recitation/type';
import TextWinds from '../../../common/TextWinds';
import { Button } from 'antd';
import RecitationResult from '../../../recitation/RecitationResult';

interface StatusByStudentContentsProps {
  selectedStudent: AssignmentStatusByStudentItem;
  handleBack: () => void;
}

/**
 * 개편 LMS (교사) - AI인증제 관리 > AI인증제 현황 페이지 > 학생별 과제 현황
 */
const StatusByStudentContents = ({
  selectedStudent,
  handleBack,
}: StatusByStudentContentsProps) => {
  return (
    <>
      <div className="mb-5 flex items-center gap-3">
        <Button
          type="default"
          className="flex shrink-0 items-center gap-2 rounded-lg px-5"
          onClick={() => {
            handleBack();
          }}
        >
          ← 학생 목록으로
        </Button>

        <div className="flex min-w-0 flex-1 items-center justify-between gap-3">
          <TextWinds type="title_h3" className="min-w-0 truncate">
            {selectedStudent.name}
          </TextWinds>
        </div>
      </div>

      <div className="w-full rounded-xl border border-gray3 bg-white px-4 py-4">
        <RecitationResult isTeacherAccount studentUid={selectedStudent.uid} />
      </div>
    </>
  );
};

export default StatusByStudentContents;
